export default __webpack_public_path__ + "static/media/bot-10.1fd6d74a.png";